import { useEffect, useState } from 'react';

const useAuthButton = () => {
  const [permissions, setPermissions] = useState<string[]>([]);
  const [roleKey, setRoleKey] = useState<string>('');
  useEffect(() => {
    try {
      // @ts-ignore
      const userInfo = JSON.parse(window.localStorage.getItem('$UserInfo$'));
      setPermissions(userInfo.permissions || []);
      setRoleKey(userInfo.roleKey || '');
    } catch {}
  }, []);
  const checkPermissionDisabled = (permission?: string) => {
    if (!permission || permissions?.includes('*:*:*') || permissions?.includes(permission)) return false;
    // 服务商和客户角色默认拥有工单操作权限
    if ((roleKey === 'provider' || roleKey === 'customer') && permission.startsWith('workorder:')) return false;
    return true;
  };
  return { permissions, checkPermissionDisabled };
};

export default useAuthButton;
